import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { api, imgSrc } from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

export default function Press() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/content/press").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="press-page">
      <PageHero
        eyebrow="In The News"
        title="Media & Press"
        sub="Television appearances, press coverage, interviews, and milestones from the world of Poolside Cooking."
      />
      <section className="py-16 sm:py-24 bg-white">
        <div className="container-site">
          {items.map((item, i) => (
            <Reveal key={item.id}>
              <article
                className="grid md:grid-cols-12 gap-8 py-12 border-b border-slate-200 first:pt-0 items-center"
                data-testid={`press-item-${item.id}`}
              >
                <div className="md:col-span-4">
                  <div className="aspect-video overflow-hidden bg-slate-100">
                    <img
                      src={imgSrc(item.image)}
                      alt={item.title}
                      loading="lazy"
                      className="img-zoom h-full w-full object-cover"
                    />
                  </div>
                </div>
                <div className="md:col-span-8">
                  <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-pool mb-3">
                    {item.kind}
                    {item.outlet ? ` · ${item.outlet}` : ""}
                    {item.date ? ` · ${item.date}` : ""}
                  </p>
                  <h2 className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-slate-900">
                    {item.title}
                  </h2>
                  {item.excerpt && <p className="mt-4 text-slate-600 leading-relaxed max-w-2xl">{item.excerpt}</p>}
                  {item.link ? (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noreferrer"
                      className="link-underline mt-6"
                      data-testid={`press-link-${item.id}`}
                    >
                      Read more <ArrowUpRight className="h-4 w-4" />
                    </a>
                  ) : (
                    <span className="mt-6 inline-block text-[11px] tracking-[0.2em] uppercase font-semibold text-slate-400">
                      Link coming soon
                    </span>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
          {items.length === 0 && (
            <p className="text-slate-500 text-sm py-16 text-center" data-testid="press-empty">
              Press coverage coming soon.
            </p>
          )}

          <Reveal className="mt-16 bg-slate-950 text-white p-10 sm:p-14">
            <h3 className="font-display font-bold text-2xl sm:text-3xl">Media inquiries</h3>
            <p className="mt-4 text-slate-400 text-sm leading-relaxed max-w-xl">
              For interviews, appearances, press assets, or media requests, reach the Poolside Cooking team
              directly.
            </p>
            <Link
              to="/contact"
              className="mt-8 inline-flex items-center gap-3 bg-pool hover:bg-pool-dark text-white text-xs tracking-[0.18em] uppercase font-semibold px-7 py-4 transition-colors"
              data-testid="press-contact-cta"
            >
              Contact the team <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
